<template>
  <div v-cloak>
    <b-alert show variant="danger" v-if="messages.error">{{messages.error}}</b-alert>
    <b-alert show variant="warning" v-if="messages.warning">{{messages.warning}}</b-alert>
    <b-alert show variant="info" v-if="messages.info">{{messages.info}}</b-alert>
  </div>
</template>

<script>
export default {
  props: {
    messages: {
      info: "",
      error: "",
      warning: ""
    },
  }
}
</script>